import { DocumentMetadata } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const uploadExecutiveSummaryFileContent: (
  fetchContext: FetchContext,
  nominationId: number,
  documentContent: File,
  accessToken?: string,
) => Promise<DocumentMetadata> = (fetchContext, nominationId, documentContent, accessToken) => {
  const formData = new FormData();
  formData.append('documentUploadRequest', documentContent);

  return fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/executive-summary-file-content`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  }).then((response) => responseErrorHandler<DocumentMetadata>(fetchContext.errorStore, response, 'upload executive summary file content'));
};
